import * as ActionCable from '@rails/actioncable'

// Create a singleton ActionCable connection
let cable = null

export function getCable() {
    if (!cable) {
        // Get WebSocket URL
        const wsUrl = window.location.protocol === 'https:' ? 'wss://' : 'ws://'
        const cableUrl = wsUrl + window.location.host + '/cable'
        
        cable = ActionCable.createConsumer(cableUrl)
    }
    return cable
}

export function createSubscription(channelConfig, callbacks = {}) {
    const consumer = getCable()
    
    return consumer.subscriptions.create(channelConfig, {
        received: callbacks.received || (() => {}),
        connected: callbacks.connected || (() => console.log('Connected to', channelConfig.channel)),
        disconnected: callbacks.disconnected || (() => console.log('Disconnected from', channelConfig.channel)),
        rejected: callbacks.rejected || (() => console.warn('Rejected from', channelConfig.channel))
    })
}